import { BaseControl } from "../base-control";

class EmbedHtmlControlCtrl extends BaseControl {
  constructor(BaseControlService, $scope, $interval, $sce, $element) {
    'ngInject';
    super(BaseControlService, $scope);
    Object.assign(this, {$interval, $sce, $element});
  }

  async initializeControlData() {
    await super.initializeControlData();
    if (this.token.options?.embedUrlType) {
      this.setEmbeddedTableWatcher(this.token.control.resizeSelector);
      await this.loadReportModel();
    }
    this.setReadOnlyHtml();
  }  
  
  setReadOnlyHtml() {
    const htmlValue = this.FF.isDefined(this.model?.display) ? this.model.display : this.model?.value;
    const htmlString = this.FF.isDefined(htmlValue) ? htmlValue.toString() : '';
    this.readOnlyHtml = this.$sce.trustAsHtml(htmlString);
  }

  async loadReportModel() {
    const url = this.model?.value || this.model?.display;
    if (url) {
      const res = await this.rcs.queryEmbeddedHtml({url});
      this.model.display = res.data.html;
    } else {
      this.model.display = '';
    }
  }
  
  setEmbeddedTableWatcher(resizeSelector) {
    if (!resizeSelector) return;

    const embedInterval = this.$interval(_ => {
      const $resizeEl = this.$element.find(resizeSelector);
      if (!$resizeEl.length) return;
      
      // For PDF: prevent URL text from displaying and resizing cells
      // TODO should somehow restrict to puppeteer only
      $resizeEl.find('td a').attr('href', '#');
      
      this.embedWatcher = new ResizeObserver(_ => this.embedResize($resizeEl, this.$element));
      this.embedWatcher.observe($resizeEl[0]);
      this.$interval.cancel(embedInterval)
    }, 200)
  }
  
  embedResize($resizeEl, $element) {
    const reductionRatio = ($element.parent().width() - 4)/$resizeEl.width();
    if (reductionRatio >= 1) return; // table already fits 
    $resizeEl.css('transform', `scale(${reductionRatio})`);
    $resizeEl.parent().height($resizeEl.height() * reductionRatio);
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/embed-html-control/embed-html-control.component.html",
  controller: EmbedHtmlControlCtrl
};